function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1996(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 23.6,
    height: 8.47,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.2100000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.8,
    y: 4.235,
    fontFamily: "Arial"
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 8.47,
    width: 23.6,
    height: 9.09,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.01
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.8,
    y: 13.015,
    fontFamily: "Arial"
  }, "\n        Lafayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 17.56,
    width: 23.6,
    height: 13.43,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.2383333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.8,
    y: 24.275,
    fontFamily: "Arial"
  }, "\n        Glades\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 30.99,
    width: 23.6,
    height: 13.55,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.71
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.8,
    y: 37.765,
    fontFamily: "Arial"
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 44.54,
    width: 23.6,
    height: 14.38,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.8,
    y: 51.73,
    fontFamily: "Arial"
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 58.92,
    width: 23.6,
    height: 14.87,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.9739999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.8,
    y: 66.355,
    fontFamily: "Arial"
  }, "\n        Dixie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 73.8,
    width: 23.6,
    height: 16.28,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.325714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.8,
    y: 81.94,
    fontFamily: "Arial"
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 90.07,
    width: 23.6,
    height: 17.89,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.23625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.8,
    y: 99.01499999999999,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 107.96,
    width: 23.6,
    height: 18.77,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.0855555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.8,
    y: 117.345,
    fontFamily: "Arial"
  }, "\n        Gilchrist\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 126.73,
    width: 23.6,
    height: 18.82,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.091111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.8,
    y: 136.14000000000001,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 145.55,
    width: 23.6,
    height: 21.87,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.1242857142857146
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.8,
    y: 156.485,
    fontFamily: "Arial"
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 167.42,
    width: 23.6,
    height: 23.46,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.865
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.8,
    y: 179.14999999999998,
    fontFamily: "Arial"
  }, "\n        Gulf\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 190.88,
    width: 23.6,
    height: 24.29,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9333333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.8,
    y: 203.025,
    fontFamily: "Arial"
  }, "\n        Hardee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 215.17,
    width: 23.6,
    height: 25.98,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.720000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.8,
    y: 228.16,
    fontFamily: "Arial"
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 241.15,
    width: 23.6,
    height: 26.63,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9333333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.8,
    y: 254.465,
    fontFamily: "Arial"
  }, "\n        Holmes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 267.79,
    width: 23.6,
    height: 28.06,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3714285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.8,
    y: 281.82,
    fontFamily: "Arial"
  }, "\n        Wakulla\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 295.85,
    width: 23.6,
    height: 29.33,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9333333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.8,
    y: 310.51500000000004,
    fontFamily: "Arial"
  }, "\n        Desoto\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 325.18,
    width: 23.6,
    height: 30.77,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.3600000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.8,
    y: 340.565,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 355.95,
    width: 23.6,
    height: 31.3,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9333333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.8,
    y: 371.59999999999997,
    fontFamily: "Arial"
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 387.25,
    width: 23.6,
    height: 32.29,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.95
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.8,
    y: 403.395,
    fontFamily: "Arial"
  }, "\n        Bradford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 419.54,
    width: 23.6,
    height: 34.83,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9333333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.8,
    y: 436.95500000000004,
    fontFamily: "Arial"
  }, "\n        Hendry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 454.37,
    width: 23.6,
    height: 38.91,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.3600000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.8,
    y: 473.825,
    fontFamily: "Arial"
  }, "\n        Okeechobee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 493.29,
    width: 23.6,
    height: 43.31,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.9
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.8,
    y: 514.945,
    fontFamily: "Arial"
  }, "\n        Levy\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 536.6,
    width: 23.6,
    height: 47.54,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.95
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.8,
    y: 560.37,
    fontFamily: "Arial"
  }, "\n        Suwannee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 584.14,
    width: 23.6,
    height: 55.58,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3714285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.8,
    y: 611.93,
    fontFamily: "Arial"
  }, "\n        Gadsden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 639.72,
    width: 23.6,
    height: 60.28,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9333333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.8,
    y: 669.86,
    fontFamily: "Arial"
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.6,
    y: 0,
    width: 29.15,
    height: 49.17,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.164285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.175,
    y: 24.585,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.75,
    y: 0,
    width: 29.16,
    height: 49.17,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.86
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 67.33,
    y: 24.585,
    fontFamily: "Arial"
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.91,
    y: 0,
    width: 30.68,
    height: 49.17,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.835
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 97.25,
    y: 24.585,
    fontFamily: "Arial"
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112.59,
    y: 0,
    width: 37.73,
    height: 49.17,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.39
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.455,
    y: 24.585,
    fontFamily: "Arial"
  }, "\n        Flagler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 150.31,
    y: 0,
    width: 39.77,
    height: 49.17,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.628333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 170.195,
    y: 24.585,
    fontFamily: "Arial"
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 190.09,
    y: 0,
    width: 47.26,
    height: 49.17,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.876666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.72,
    y: 24.585,
    fontFamily: "Arial"
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 237.35,
    y: 0,
    width: 61.15,
    height: 49.17,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.195
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 267.925,
    y: 24.585,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 298.5,
    y: 0,
    width: 63.35,
    height: 49.17,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.463333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 330.175,
    y: 24.585,
    fontFamily: "Arial"
  }, "\n        Highlands\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 361.85,
    y: 0,
    width: 79.69,
    height: 49.17,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.917
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 401.69500000000005,
    y: 24.585,
    fontFamily: "Arial"
  }, "\n        Santa_Rosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 441.53,
    y: 0,
    width: 82.62,
    height: 49.17,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.0975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 482.84,
    y: 24.585,
    fontFamily: "Arial"
  }, "\n        Indian_River\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 524.16,
    y: 0,
    width: 87.36,
    height: 49.17,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.024285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 567.8399999999999,
    y: 24.585,
    fontFamily: "Arial"
  }, "\n        Osceola\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 611.51,
    y: 0,
    width: 88.49,
    height: 49.17,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.2925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 655.755,
    y: 24.585,
    fontFamily: "Arial"
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.6,
    y: 49.17,
    width: 75.95,
    height: 59.05,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.561111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.575,
    y: 78.695,
    fontFamily: "Arial"
  }, "\n        St._Johns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.6,
    y: 108.22,
    width: 75.95,
    height: 60.33,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.055
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.575,
    y: 138.385,
    fontFamily: "Arial"
  }, "\n        Citrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.6,
    y: 168.55,
    width: 75.95,
    height: 62.88,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 20.96
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.575,
    y: 199.99,
    fontFamily: "Arial"
  }, "\n        Bay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.6,
    y: 231.43,
    width: 75.95,
    height: 66.48,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.08
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.575,
    y: 264.67,
    fontFamily: "Arial"
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.6,
    y: 297.92,
    width: 75.95,
    height: 70.63,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.82875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.575,
    y: 333.235,
    fontFamily: "Arial"
  }, "\n        Hernando\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.6,
    y: 368.55,
    width: 75.95,
    height: 76.66,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.43888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.575,
    y: 406.88,
    fontFamily: "Arial"
  }, "\n        Charlotte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.6,
    y: 445.21,
    width: 75.95,
    height: 76.69,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.49375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.575,
    y: 483.55499999999995,
    fontFamily: "Arial"
  }, "\n        Okaloosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.6,
    y: 521.89,
    width: 75.95,
    height: 88.21,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.85
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.575,
    y: 565.995,
    fontFamily: "Arial"
  }, "\n        Collier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.6,
    y: 610.1,
    width: 75.95,
    height: 89.9,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.43888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.575,
    y: 655.0500000000001,
    fontFamily: "Arial"
  }, "\n        St._Lucie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.55,
    y: 49.17,
    width: 68.28,
    height: 100.02,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.07
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.69,
    y: 99.18,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.84,
    y: 49.17,
    width: 68.83,
    height: 100.02,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.832857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 202.255,
    y: 99.18,
    fontFamily: "Arial"
  }, "\n        Alachua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 236.67,
    y: 49.17,
    width: 83.29,
    height: 100.02,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.881666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 278.315,
    y: 99.18,
    fontFamily: "Arial"
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 319.96,
    y: 49.17,
    width: 84.72,
    height: 100.02,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 21.18
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 362.32,
    y: 99.18,
    fontFamily: "Arial"
  }, "\n        Leon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 404.68,
    y: 49.17,
    width: 89.49,
    height: 100.02,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.784285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 449.425,
    y: 99.18,
    fontFamily: "Arial"
  }, "\n        Manatee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 494.17,
    y: 49.17,
    width: 99.69,
    height: 100.02,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.46125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 544.015,
    y: 99.18,
    fontFamily: "Arial"
  }, "\n        Escambia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 593.86,
    y: 49.17,
    width: 106.14,
    height: 100.02,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.5025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 646.9300000000001,
    y: 99.18,
    fontFamily: "Arial"
  }, "\n        Seminole\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.55,
    y: 149.18,
    width: 127.26,
    height: 96.89,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.378
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 163.18,
    y: 197.625,
    fontFamily: "Arial"
  }, "\n        Pasco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.55,
    y: 246.08,
    width: 127.26,
    height: 108.16,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.52
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 163.18,
    y: 300.16,
    fontFamily: "Arial"
  }, "\n        Sarasota\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.55,
    y: 354.24,
    width: 127.26,
    height: 109.02,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 27.255
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 163.18,
    y: 408.75,
    fontFamily: "Arial"
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.55,
    y: 463.26,
    width: 127.26,
    height: 116.27,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.61
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 163.18,
    y: 521.395,
    fontFamily: "Arial"
  }, "\n        Volusia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.55,
    y: 579.53,
    width: 127.26,
    height: 120.47,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 40.156666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 163.18,
    y: 639.765,
    fontFamily: "Arial"
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 226.82,
    y: 149.18,
    width: 135.71,
    height: 132.84,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.97714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 294.675,
    y: 215.60000000000002,
    fontFamily: "Arial"
  }, "\n        Brevard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 362.52,
    y: 149.18,
    width: 160.74,
    height: 132.84,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.14
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 442.89,
    y: 215.60000000000002,
    fontFamily: "Arial"
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 523.27,
    y: 149.18,
    width: 176.73,
    height: 132.84,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 26.568
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 611.635,
    y: 215.60000000000002,
    fontFamily: "Arial"
  }, "\n        Duval\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 226.82,
    y: 282.03,
    width: 151.31,
    height: 188.23,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.609166666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 302.475,
    y: 376.145,
    fontFamily: "Arial"
  }, "\n        Hillsborough\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 226.82,
    y: 470.25,
    width: 151.31,
    height: 229.75,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.91375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 302.475,
    y: 585.125,
    fontFamily: "Arial"
  }, "\n        Pinellas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 378.12,
    y: 282.03,
    width: 141.72,
    height: 259.03,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.172
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 448.98,
    y: 411.54499999999996,
    fontFamily: "Arial"
  }, "\n        Palm_Beach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 519.85,
    y: 282.03,
    width: 180.15,
    height: 259.03,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 25.735714285714288
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 609.9250000000001,
    y: 411.54499999999996,
    fontFamily: "Arial"
  }, "\n        Broward\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 378.12,
    y: 541.05,
    width: 321.88,
    height: 158.95,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.895
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 539.06,
    y: 620.525,
    fontFamily: "Arial"
  }, "\n        Miami-Dade\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1996);
export default __webpack_public_path__ + "static/media/1996.f4af3ba917819f5db2d6c06d17de156f.svg";
export { ForwardRef as ReactComponent };